import { PATH } from "./path";

export const LINK_GAME = [
  { link: PATH.gameLivePage, name: "Live Casino" },
  { link: PATH.gameSlotsPage, name: "Slots" },
  { link: PATH.gameSportPage, name: "Sport" },
  { link: PATH.gameESportPage, name: "ESport" },
  // { link: PATH.info.andarBabarLive, name: "Andar bahar live" },
  // { link: PATH.info.blackJackLive, name: "Blackjack live" },
  // { link: PATH.info.lightningDiceLive, name: "Lightning dice live" },
  // { link: PATH.info.crazyTimeLine, name: "Crazy time live" },
  // { link: PATH.info.dragonTigerLive, name: "Dragon tiger live" },
  // { link: PATH.info.lightningRouletteLive, name: "Lighting roulette live" },
  // { link: PATH.info.teenPattiLive, name: "Teen patti live" },
];
export const LINK_TIPS = [
  { link: PATH.info.wager, name: "What is wager" },
  {
    link: PATH.info.growpay,
    name: "Instructions for P2P UPI & IMPS payment method",
  },
  { link: PATH.info.upi, name: "What is UPI" },
  {
    link: PATH.info.upiRegistration,
    name: "UPI Registration - Step-by-Step Guide",
  },
  { link: PATH.info.depositInstructions, name: "How to make a deposit" },
  { link: PATH.info.withdrawalInstructions, name: "How to withdraw funds" },
  { link: PATH.info.howToChoose, name: "Casino Table Games You Should Try" },
  {
    link: PATH.info.paymentWithdrawalMethods,
    name: "Payments & withdrawal methods",
  },
  {
    link: PATH.info.blog,
    name: "Blog",
  },
];
export const LINK_INFO = [
  { link: PATH.info.freeBets, name: "Free Bets" },
  { link: PATH.info.promoCodes, name: "RRRBets Promo Code" },
  { link: PATH.info.androidApp, name: "RRRBets android app" },
  {
    link: PATH.info.changeAccount,
    name: "How to change currency of your account",
  },
  { link: PATH.info.contactUs, name: "Contact Us" },
  { link: PATH.info.about, name: "About" },
  { link: PATH.info.terms, name: "Terms and conditions" },
  { link: PATH.info.responsibleGaming, name: "Responsible gaming" },
  { link: PATH.info.selfExclusionPolicy, name: "Self-exclusion Policy" },
  { link: PATH.info.kyc, name: "KYC Policy" },
  { link: PATH.info.faq, name: "FAQ" },
  { link: PATH.info.bettingRules, name: "Betting Rules" },
  { link: PATH.info.privacy, name: "Privacy policy" },
];
export const LINK_PROMOTIONS = [
  { link: PATH.info.instaPromoCode, name: "RRRBets INSTA Promo Code" },
  { link: PATH.info.sportsCashback, name: "Sports Cashback 10%" },
  { link: PATH.info.multipleBonus, name: "Multiple Bonus +50%" },
  { link: PATH.newsPage, name: "News" },
  { link: PATH.bonusPage, name: "Bonuses" },
  { link: PATH.info.infoLoyaltyProgram, name: "Information Loyalty Program" },
];
